/*!
??TEST
=========================================================
* Argon Dashboard React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useState, useEffect } from "react";


// node.js library that concatenates classes (strings)
import classnames from "classnames";
// javascipt plugin for creating charts
import Chart from "chart.js";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";
import Plot from 'react-plotly.js';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import {
  chartOptions,
  parseOptions,
  chartExample1,
  chartExample2,
} from "variables/charts.js";

import Header from "components/Headers/Header.js";
import Map from "views/Map.js"
import ProjectData from "assets/data/OffshoreWindProjectList-April2024.json"
// import timeseriesData from 'assets/dummy_data/timeseries.json'
import TimeseriesPlot from "components/Plots/timeseries";


const About = (props) => {


  return (
    <>
      {/* Page content */}
      <Container fluid style={{margin:5, backgroundColor:'white'}}>
        <div className="bg-gradient-default" style={{marginTop:20, padding:10, borderWidth:5, borderRadius: 20}}>

          <h1 style={{color:'white'}}> About VOWELS </h1>
          <p style={{textAlign: 'justify',color:'white'}}>
            The Virtual Offshore Wind Energy Laboratory & Simulator (VOWELS) project is a UAlbany-led program to study the weather-driven dynamics of over 30 GW of future offshore wind energy capacity planned for development off the East Coast of the United States. Massive amounts of new offshore wind generation will shift the electricity resource profile of this meteorologically-active region to one that is more weather-sensitive and changeable. To help manage expectations and risk, VOWELS is designed to provide involved stakeholders—grid operators, project developers, government planners, researchers—with foreknowledge of the nature and predictability of offshore wind power output via a combination of research, forecasting, and collaborative approaches.
          </p>
          <p style={{textAlign: 'justify',color:'white'}}>
            The research component of VOWELS investigates the nature and probabilities of different weather phenomena that significantly influence wind energy production behavior. High-impacts events can consist of: the sudden loss of full-capacity energy production when regional wind conditions exceed project cut-out speeds; steep generation ramps (positive and negative) over short time intervals due to the passage of squall lines or routine weather systems; sea breezes that often occur during peak load conditions; and long-duration wind lulls. This program component also explores the potential impacts of climate change on extreme events probabilities over the lifetime of offshore wind projects.
          </p>
          <p style={{textAlign: 'justify',color:'white'}}>
            The forecasting component of VOWELS uses an online dashboard to display the location and predicted real-time output of all offshore wind projects as if they were operating today. UAlbany has partnered with UL Solutions to produce these forecasts. An ensemble forecasting system employing several numerical weather prediction (NWP) and machine learning models produces 24-hour outlooks for winds and power output. Initial meteorological conditions are defined by NOAA's High-Resolution Rapid Refresh NWP model. Each ensemble member is weighted according to its past performance to optimize forecasts, which are updated hourly.
          </p>
          <p style={{textAlign: 'justify',color:'white'}}>
            Currently, the dashboard assumes that all planned projects use a modified version of an International Energy Agency power curve for a generic 15 MW turbine and 150 m hub height. High-speed cutouts are modeled as a smooth down ramp in generation between 25 and 31 m/s. The maximum net power generation for each offshore project is assumed to be 85% of its nameplate capacity due to expected minimum loss factors (e.g., wakes, transmission line losses, etc.). In the future, project-specific turbine models and configurations will be incorporated, as will wakes losses induced by other, upwind projects.
          </p>
          <p style={{textAlign: 'justify',color:'white'}}>
            Another VOWELS component is an Advisory Committee whose primary role is to provide guidance on research area priorities and dashboard content and functionality. The committee, comprised of a cross-section of industry representatives, also serves as a collaborative forum for information exchange about committee members’ own offshore wind-related studies and grid integration concerns.
          </p>
        </div>


      </Container>
    </>
  );
};

export default About;


